module.exports = __webpack_public_path__ + "static/media/IL.8cfa7ba1.svg";